import React, { FC } from "react";
import styled from "styled-components";

interface PdfProps {
  pdfThumbnailUrl: string;
}

const Pdf: FC<PdfProps> = ({ pdfThumbnailUrl }) => {
  return (
    <Relative>
      <Image src={pdfThumbnailUrl} alt="pdf" />
      <Thumbnail src={require("assets/image/pdf.webp")} alt="thumbnail" />
    </Relative>
  );
};

export default Pdf;

const Relative = styled.div`
  position: relative;
`;
const Image = styled.img`
  width: 100%;
  max-height: 480px;
  object-fit: cover;
  object-position: center;
`;
const Thumbnail = styled.img`
  position: absolute;
  height: 60px;
  bottom: 5px;
  right: 5px;
`;
